var mp = mp || {};

// Form validation
//----------------------------------------------------------
mp.formContact = function() {
    var $form = $('#form-contact');
        $submitBtn = $form.find('button.btn');

    if (!$form.length) {
        return;
    }

    $form.validate({
        rules: {
            first_name: {
                required: true,
                minlength: 2
            },
            last_name: {
                required: true,
                minlength: 2
            },
            email: {
                required: true,
                email: true
            },
            message: {
                required: true,
                minlength: 5
            },
        },
        errorPlacement: function(error, element) {
            //element.addClass("test");
        },

        invalidHandler: function(event, validator) {
            // $submitBtn.toggleClass('disabled');
        },

        submitHandler: function(form) {
            $submitBtn.attr('disabled','disabled');

            $.ajax({
                url: form.action,
                type: form.method,
                data: $(form).serialize(),
                success: function(response) {
                    $submitBtn.removeAttr('disabled'),

                    response = jQuery.parseJSON(response);

                    if (response.status=="success") {
                        form.reset();

                        alert(response.msg);
                    } else {
                        alert(response.msg);
                    }
                }            
            });
        }

    });
};



$(document).ready(function (){
    mp.formContact();
});